import React from "react"
import { Product } from "../../../shared/sdk/types"
import { useLocalesState } from "../../../shared/context/locales"
import { formatPrice } from "../../../shared/utils/format"
import i18n from "../../../i18n/config"
import { RichTextExt, plugins } from "react-bricks/frontend"
import { RenderElementProps } from "slate-react"

export interface MatrixRedesignItemInfoBoxProps {
    product?: Product
}

const MatrixRedesignItemInfoBox = ({ product }: MatrixRedesignItemInfoBoxProps) => {
    const { language } = useLocalesState()

    const { unorderedList } = plugins

    const subscriptionNotes = product?.configuration.subscription
        ? [
              i18n.t("product_matrix_subscription_checklist_1", {
                  amount: product.configuration.subscription!.max_quantity,
              }),
              i18n.t("product_matrix_subscription_checklist_2", {
                  discount_price: formatPrice(
                      (product.price.current.taxed * (product.configuration.subscription.max_quantity - 1)) /
                          product.configuration.subscription.max_quantity,
                      product.price.currency.name,
                      language
                  ),
                  amount: product.configuration.subscription!.max_quantity,
              }),
              i18n.t("product_matrix_subscription_checklist_3", {
                  discount_percentage:
                      i18n.language !== "en"
                          ? (100 / product.configuration.subscription.max_quantity).toLocaleString("de-DE", {
                                maximumFractionDigits: 1,
                            })
                          : (100 / product.configuration.subscription.max_quantity).toFixed(1),
              }),
          ]
        : null

    return (
        <div className="mb-5 w-full rounded-[30px] bg-background-tide px-7 py-5 font-semibold sm:mb-7 sm:rounded-xl sm:px-10 sm:py-7 lg:rounded-[46px]">
            {subscriptionNotes ? (
                <ul className="text-sm sm:text-base">
                    {subscriptionNotes.map((note, index) => (
                        <li
                            key={index}
                            data-before=""
                            className="relative mb-2 pl-6 before:absolute before:left-0 before:top-0 before:z-2 before:font-['lavita-icon-font'] before:text-sm before:content-[attr(data-before)] last:mb-0"
                        >
                            {note}
                        </li>
                    ))}
                </ul>
            ) : (
                <RichTextExt
                    propName="checklist"
                    placeholder="Lorem ipsum"
                    renderBlock={({ children }) => <>{children}</>}
                    plugins={[
                        {
                            ...unorderedList,
                            renderElement: ({ children, attributes }: RenderElementProps) => (
                                <ul {...attributes} className="text-sm sm:text-base">
                                    {children}
                                </ul>
                            ),
                            renderItemElement: ({ children, attributes }: RenderElementProps) => (
                                <li
                                    {...attributes}
                                    data-before=""
                                    className="relative mb-2 pl-6 before:absolute before:left-0 before:top-0 before:z-2 before:font-['lavita-icon-font'] before:text-sm before:content-[attr(data-before)] last:mb-0"
                                >
                                    {children}
                                </li>
                            ),
                        },
                    ]}
                />
            )}
        </div>
    )
}

MatrixRedesignItemInfoBox.schema = {
    name: "MatrixRedesignItemInfoBox",
    label: "Matrix Redesign Item InfoBox",
    hideFromAddMenu: true,
}

export default MatrixRedesignItemInfoBox
